/**
 * Converts date format to the format exposed to assistive technologies.
 * @see https://flatpickr.js.org/formatting/
 * @param {String} format
 */
const a11yDateFormat = (format) =>
  format
    // day
    .replace(/[dj]/, 'dd')
    // month
    .replace(/[mn]/, 'mm')
    // year
    .replace('y', 'yy')
    .replace('Y', 'yyyy')
    // hours
    .replace(/[hH]/, 'h')
    // minutes
    .replace('i', 'm')
    // seconds
    .replace(/[sS]/, 's')
    .replace('K', 'AM/PM');

export default a11yDateFormat;
